<template lang="pug">
.form-developer-about
  .form-developer-about-dog
    span.form-developer-about__header
        | Анонс

    .form-developer-about__text
        ckeditor(
            v-model="preview_text"
            :editor="editor"
            :config="editorConfig"
        )
  FormDeveloperAboutDogNail
</template>

<script>
// .form-developer-about__text
//     ckeditor(
//         v-model="preview_text"
//         :editor="editor"
//         :config="editorConfig"
//     )

// span.form-developer-about__header
//     | Полное описание

// .form-developer-about__text
//     ckeditor.ckeditor.ck-editor.ck-content(
//         v-model="detail_text"
//         :editor="editor"
//         :config="editorConfig"
//     )


import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapGetters, mapMutations } from 'vuex';

import FormDeveloperAboutDogNail from './FormDeveloperAboutDogNail';

export default {
  name: 'FormDeveloperAbout',

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          // Upload the images to the server using the CKFinder QuickUpload command.
          uploadUrl: '/admin/developers/' + this.$route.params.id + '/upload-inline-image',

          // Define the CKFinder configuration (if necessary).
          options: {
            resourceType: 'Images',
            pass: 5,
          },
        },
        toolbar: {
          viewportTopOffset: 0,
        },
        language: 'ru',
      },
    };
  },

  mounted() {
  },
  updated() {
  },

  computed: {
    ...mapGetters({
      current: 'developer/getCurrent',
    }),

    detail_text: {
      get() { return this.current.detail_text; },
      set(detail_text) { this.setValue({ detail_text }); },
    },

    preview_text: {
      get() { return this.current.preview_text; },
      set(preview_text) { this.setValue({ preview_text }); },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'developer/setValue',
    }),
  },
  components: {
    FormDeveloperAboutDogNail,
  },
};
</script>

<style lang="scss">
.form-developer-about {
    // display: grid;
    // grid-template-columns: 265px 1fr;
    // grid-column-gap: 50px;
    // grid-row-gap: 50px;
    // justify-items: end;
    // align-items: start;
    margin-top: 50px;
    padding-right: 80px;
    padding-left: 40px;

    &__text {
        width: 100%;
    }
}
.form-developer-about-dog {
  display: flex;
}

.form-developer-about__header {
  min-width: 200px;
  min-width: 180px;
    text-align: end;
}

.form-developer-about__text {
    margin-bottom: 50px;
    margin-left: 40px;
}

.ckeditor {
  height: 100%;
}
</style>
